var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0613 20.9386C13.3431 21.2204 13.5014 21.6026 13.5014 22.0011C13.5014 22.3997 13.3431 22.7818 13.0613 23.0636C12.7795 23.3454 12.3973 23.5037 11.9988 23.5037C11.6003 23.5037 11.2181 23.3454 10.9363 23.0636L0.936299 13.0636C0.796459 12.9243 0.685505 12.7587 0.609797 12.5764C0.534088 12.394 0.495117 12.1986 0.495117 12.0011C0.495117 11.8037 0.534088 11.6082 0.609797 11.4259C0.685505 11.2436 0.796459 11.078 0.936299 10.9386L10.9363 0.938637C11.2181 0.656844 11.6003 0.498535 11.9988 0.498535C12.3973 0.498535 12.7795 0.656845 13.0613 0.938637C13.3431 1.22043 13.5014 1.60262 13.5014 2.00114C13.5014 2.39965 13.3431 2.78184 13.0613 3.06364L4.12505 11.9999L13.0613 20.9386Z",
    fill: "#FE0096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.8b0407daded26356afcb626a03cd3fba.svg";
export { ForwardRef as ReactComponent };